import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    group: {
        flexDirection: "column",
        flexBasis: 0,
        flexGrow: 1,
        minWidth: 0
    },
    links: {
        flexDirection: "column",
        minWidth: 0
    },
    sheetGroup: {
        flexBasis: "auto",
        flexGrow: 0
    }
});
export default stylesheet;
